'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var errcode = require('err-code');

var PeerId = require('peer-id');

var _require = require('../errors'),
    ERR_INVALID_PARAMETERS = _require.codes.ERR_INVALID_PARAMETERS;
/**
 * @param {any} data
 */


var passthrough = function passthrough(data) {
  return data;
};
/**
 * @typedef {import('./')} PeerStore
 */


var Book = /*#__PURE__*/function () {
  /**
   * The Book is the skeleton for the PeerStore books.
   *
   * @class
   * @param {Object} properties
   * @param {PeerStore} properties.peerStore - PeerStore instance.
   * @param {string} properties.eventName - Name of the event to emit by the PeerStore.
   * @param {string} properties.eventProperty - Name of the property to emit by the PeerStore.
   * @param {(data: any) => any[]} [properties.eventTransformer] - Transformer function of the provided data for being emitted.
   */
  function Book(_ref) {
    var peerStore = _ref.peerStore,
        eventName = _ref.eventName,
        eventProperty = _ref.eventProperty,
        _ref$eventTransformer = _ref.eventTransformer,
        eventTransformer = _ref$eventTransformer === void 0 ? passthrough : _ref$eventTransformer;

    _classCallCheck(this, Book);

    this._ps = peerStore;
    this.eventName = eventName;
    this.eventProperty = eventProperty;
    this.eventTransformer = eventTransformer;
    /**
     * Map known peers to their data.
     *
     * @type {Map<string, any[]|any>}
     */

    this.data = new Map();
  }
  /**
   * Set known data of a provided peer.
   *
   * @param {PeerId} peerId
   * @param {any[]|any} data
   */


  _createClass(Book, [{
    key: "set",
    value: function set(peerId, data) {
      throw errcode(new Error('set must be implemented by the subclass'), 'ERR_NOT_IMPLEMENTED');
    }
    /**
     * Set data into the datastructure, persistence and emit it using the provided transformers.
     *
     * @protected
     * @param {PeerId} peerId - peerId of the data to store
     * @param {any} data - data to store.
     * @param {Object} [options] - storing options.
     * @param {boolean} [options.emit = true] - emit the provided data.
     * @returns {void}
     */

  }, {
    key: "_setData",
    value: function _setData(peerId, data) {
      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref2$emit = _ref2.emit,
          emit = _ref2$emit === void 0 ? true : _ref2$emit;

      var b58key = peerId.toB58String(); // Store data in memory

      this.data.set(b58key, data); // Emit event

      emit && this._emit(peerId, data);
    }
    /**
     * Emit data.
     *
     * @protected
     * @param {PeerId} peerId
     * @param {any} [data]
     */

  }, {
    key: "_emit",
    value: function _emit(peerId, data) {
      this._ps.emit(this.eventName, _defineProperty({
        peerId: peerId
      }, this.eventProperty, this.eventTransformer(data)));
    }
    /**
     * Get the known data of a provided peer.
     * Returns `undefined` if there is no available data for the given peer.
     *
     * @param {PeerId} peerId
     * @returns {any[]|any|undefined}
     */

  }, {
    key: "get",
    value: function get(peerId) {
      if (!PeerId.isPeerId(peerId)) {
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      var rec = this.data.get(peerId.toB58String()); // @ts-ignore

      return rec ? _toConsumableArray(rec) : undefined;
    }
    /**
     * Deletes the provided peer from the book.
     *
     * @param {PeerId} peerId
     * @returns {boolean}
     */

  }, {
    key: "delete",
    value: function _delete(peerId) {
      if (!PeerId.isPeerId(peerId)) {
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      if (!this.data.delete(peerId.toB58String())) {
        return false;
      }

      this._emit(peerId, []);

      return true;
    }
  }]);

  return Book;
}();

module.exports = Book;